var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcImageDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5162_41417)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0239258,
    y: 0.302734,
    width: 80,
    height: 80,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5162_41417)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0239258,
    y: -3.7998,
    width: 80,
    height: 88.2051,
    fill: "#BAC8D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3068 50.8717L24.3113 37.2426C24.5735 36.8462 24.9888 36.5871 25.4496 36.5323C25.9105 36.4775 26.3716 36.6323 26.7138 36.9567L33.5513 43.489C33.8805 43.8007 34.3204 43.9561 34.7649 43.9177C35.2094 43.8794 35.6184 43.6507 35.8933 43.2868L47.805 28.7095C48.115 28.2996 48.5928 28.0642 49.0954 28.0738C49.598 28.0834 50.0671 28.3368 50.3624 28.7583L63.6066 50.8369C63.9614 51.3421 64.0121 52.0109 63.7379 52.5674C63.4636 53.1238 62.9109 53.4735 62.3078 53.4721H16.6258C16.0308 53.472 15.4848 53.1303 15.208 52.5847C14.9312 52.039 14.9693 51.3794 15.3068 50.8717ZM33.309 34.7886C31.105 34.7886 29.3182 32.9377 29.3182 30.6546C29.3182 28.3714 31.105 26.5205 33.309 26.5205C35.5131 26.5205 37.2998 28.3714 37.2998 30.6546C37.2998 32.9377 35.5131 34.7886 33.309 34.7886Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5162_41417"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0239258,
    y: 0.302734,
    width: 80,
    height: 80,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5162_41417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.0239258 0.302734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImageDefault);
export default __webpack_public_path__ + "static/media/ic-image-default.c7a68191935d5270e22279b747cd191b.svg";
export { ForwardRef as ReactComponent };